export default function datlinq() {
    let token = document.querySelector("meta[name='csrf-token']").getAttribute("content");
    const formElements = document.querySelectorAll('form[data-ajax]');

    formElements.forEach((formElement) => {
        let formInputs = formElement.querySelectorAll('[name="company"], [name="postal_code"], [name="city"]');
        formInputs.forEach((formInput) => {
            formInput.addEventListener('blur', (e) => {
                getCompanies(formInputs, formElement)
            }, false);
        })
    });

    const getCompanies = (inputs, form) => {
        const companyIdInput = form.querySelectorAll('[name="company_id"]')[0];
        const data = {"_token": token};

        inputs.forEach((item) => {
            if (item.getAttribute('name') === "company") {
                data['name'] = item.value;
            }

            if (item.getAttribute('name') === "postal_code" && item.value !== '') {
                data['parameters'] = item.value.replace(/\s/g, '');
            } else if (item.getAttribute('name') === "city" && item.value !== '') {
                data['parameters'] = item.value;
            }
        });

        if (data['name'] !== '' && data['parameters'] !== '') {
            fetch(decodeURI(form.dataset.datlinqSearchRoute), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                })
                .then(data => {
                    if (! data || data.length === 0) {
                        return;
                    }

                    if (data.length === 1) {
                        const id = data[0].id
                        const name = data[0].name.split(',')[0]
                        const street = data[0].name.split(',')[1]
                        const city = capitalize(data[0].name.split(',')[2].replace(/\s/g, '').toLowerCase());
                        const formGroup = form.querySelectorAll('[name="company"]')[0].closest('.form-group');

                        let input = form.querySelectorAll('[name="company"]')[0];

                        companyIdInput.value = id;
                        input.value = name;

                        getCompanyInfo(id, form)
                    } else {
                        const formGroup = form.querySelectorAll('[name="company"]')[0].closest('.form-group');
                        const parent = document.createElement("div");
                        parent.setAttribute("class", "autocomplete-items mb-2");
                        formGroup.appendChild(parent);

                        data.forEach(function (company) {
                            const item = document.createElement("div");
                            const name = company.name.split(',')[0];
                            const street = company.name.split(',')[1];
                            const city = capitalize(company.name.split(',')[2].replace(/\s/g, '').toLowerCase());
                            item.innerHTML = "" + name + ", " + street + ", " + city + "";
                            item.setAttribute("data-company-id", company.id);
                            item.setAttribute("class", "w-full p-2 bg-gray-200 border placeholder-secondary-500 placeholder-opacity-60 focus:placeholder-opacity-30 form-control form-control");
                            item.addEventListener("click", () => {
                                const id = company.id
                                const name = company.name.split(',')[0]
                                const street = company.name.split(',')[1]
                                const city = capitalize(company.name.split(',')[2].replace(/\s/g, '').toLowerCase());
                                const formGroup = form.querySelectorAll('[name="company"]')[0].closest('.form-group')

                                let input = form.querySelectorAll('[name="company"]')[0];

                                companyIdInput.value = id;
                                input.value = name;

                                getCompanyInfo(id, form);
                                formGroup.removeChild(parent);
                            });
                            parent.appendChild(item);
                        })
                    }
                });
        }

    }

    const getCompanyInfo = (id, form) => {
        const data = {"_token": token}
        fetch(decodeURI(form.dataset.datlinqCompanyRoute).replace('[id]', id), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Geen bedrijf gevonden met dat id');
                }
            })
            .then(data => {
                const type = data.type ?? null;

                const addressInput = form.querySelectorAll('[name="address"]')[0];
                const postalCodeInput = form.querySelectorAll('[name="postal_code"]')[0];
                const cityInput = form.querySelectorAll('[name="city"]')[0];
                const phoneInput = form.querySelectorAll('[name="phone"]')[0];

                if (addressInput != null) {
                    addressInput.value = data.street + " " + data.houseNumber;
                }

                if (postalCodeInput != null) {
                    postalCodeInput.value = data.zipCode;
                }

                if (cityInput != null) {
                    cityInput.value = capitalize(data.city.replace(/\s/g, '').toLowerCase());
                }

                if (phoneInput != null) {
                    phoneInput.value = data.phoneNumber;
                }

                if (type != null) {
                    let input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    input.setAttribute("name", "customer_type");
                    input.setAttribute("value", type);
                    form.appendChild(input);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
}

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}
